import styled from 'styled-components'

export const FillerDiv = styled.div``
export const FillerInlineDiv = styled.div`
    display: inline-block;
    padding-top: ${props => (props.top ? `${props.top}px` : '0')};
`

export const HideableDiv = styled.div`
    ${props => (props.disabled ? `
        display: none;
    ` : '')};
`

export const NavigationWrapper = styled.div`
    height: 56px;
`

export const CenteredDiv = styled.div`
    text-align: center;
    margin-top: 100px;
    
    > div {
        margin: 0 auto;
    }
`

export const DivWithMargin = styled.div`
    margin-top: ${props => (props.top ? `${props.top}px ${props.important ? '!important' : ''}` : '0')};
    margin-bottom: ${props => (props.bottom ? `${props.bottom}px ${props.important ? '!important' : ''}` : '0')};
    margin-left: ${props => (props.left ? `${props.left}px ${props.important ? '!important' : ''}` : '0')};
    margin-right: ${props => (props.right ? `${props.right}px ${props.important ? '!important' : ''}` : '0')};
`

export const CenteredDivWithMargin = styled(DivWithMargin)`
    text-align: center;
    ${props => (props.fontSize ? `
        font-size: ${props.fontSize};
    ` : '')};
`

export const ContentContainer = styled.div``



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Fillers.js